import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private http = inject(HttpClient);

  dashboardView: WritableSignal<string> = signal('detail');
  showViewToggle: WritableSignal<boolean> = signal(false);

  // Global dashboard date filter (used by header date-range picker)
  dateRange: WritableSignal<string> = signal('this_year');
  fromDate: WritableSignal<string> = signal('');
  toDate: WritableSignal<string> = signal('');

  activeFilters: WritableSignal<any> = signal({});
  savedFilters: WritableSignal<any[]> = signal([]);

  updateProfileView(view: string): Observable<any> {
    return this.http.post('api/profile/update', { view });
  }
}
